import { EducationalMaterial } from '@dreryk/egabinet-knowledge-base-frontend-api';

import { EducationalMaterialCard } from './EducationalMaterialCard';
import { HorizontalScroller } from './horizontalScroller/HorizontalScroller';

type EducationalMaterialsProps = {
   educationalMaterials: EducationalMaterial[];
};

export const EducationalMaterials = (props: EducationalMaterialsProps): JSX.Element => {
   return (
      <HorizontalScroller>
         {props.educationalMaterials.map((educationalMaterial) => (
            <EducationalMaterialCard key={educationalMaterial.id} educationalMaterial={educationalMaterial} />
         ))}
      </HorizontalScroller>
   );
};
